import { msg } from "@lingui/core/macro";
import type { I18n } from "@lingui/core";
import type { RecipeType } from "@/types/recipe";
import type { ActiveTabsIds, IdToTitleKey, SectionTitleFor } from "./types";

export function getSectionTitle<T extends ActiveTabsIds>(
  activeTab: T,
  i18n: I18n,
): SectionTitleFor<IdToTitleKey[T]> {
  const title =
    activeTab === "prepRecipes"
      ? i18n._(msg`Recipes`)
      : i18n._(msg`Ingredients`);
  return title as SectionTitleFor<IdToTitleKey[T]>;
}

export function getAddLabel(
  activeTab: ActiveTabsIds,
  i18n: I18n,
): string {
  switch (activeTab) {
    case "prepRecipes":
      return i18n._(msg`Add recipe`);
    case "ingredients":
      return i18n._(msg`Add ingredient`);
  }
}

/**
 * Which dialog the Add button on the Recipes tab opens. That tab holds prep and
 * plated recipes alike, so when the list is filtered to one kind the answer is
 * known; with no filter the Create-new chooser asks.
 */
export function getAddRecipeDialog(
  recipeType: RecipeType | undefined,
): "createRecipe" | "createPrepRecipe" | "createNew" {
  if (recipeType === "PLATED") return "createRecipe";
  if (recipeType === "PREP") return "createPrepRecipe";
  return "createNew";
}

export function getCreateLabel(
  activeTab: ActiveTabsIds,
  i18n: I18n,
): string {
  switch (activeTab) {
    case "prepRecipes":
      return i18n._(msg`Create new`);
    case "ingredients":
      return i18n._(msg`Create new`);
  }
}

export function getTabs(i18n: I18n): { id: ActiveTabsIds; label: string }[] {
  return [
    { id: "prepRecipes", label: i18n._(msg`Recipes`) },
    { id: "ingredients", label: i18n._(msg`Ingredients`) },
  ];
}